import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
import { ChevronUp } from 'lucide-react';

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };


  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.3 }}
          style={{ position: 'fixed', bottom: 32, right: 25, zIndex: 1000 }}
        >
          <Fab 
            color="primary" 
            aria-label="scroll back to top" 
            onClick={scrollToTop}
            sx={{
              
              borderRadius: '100%', 
              width: {sm:'50px',xs:'40px'},
              height: {sm:'50px',xs:'40px'},
            }}
          >
            <ChevronUp />
          </Fab>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


export default ScrollToTopButton;
